import ApiRequest from '../api/ApiRequest';

const apiRequest = new ApiRequest('applications');

export default {
  state: {
    apps: [],
  },
  namespaced: true,
  mutations: {
    async saveAppsStore(state, apps) {
      state.apps = apps;
    },
    async createApp(state, application) {
      const apps = state.apps.concat(application.data);
      state.apps = apps;
    },
    async updateApp(state, application) {
      const index = state.apps.findIndex((el) => el.id === application.data.id);
      Object.assign(state.apps[index], application.data);
    },
  },
  actions: {
    async saveAppsStore({ commit }, data) {
      commit('saveAppsStore', await apiRequest.getAll(data));
    },
    async createApp({ commit }, application) {
      commit('createApp', await apiRequest.create(application));
    },
    async updateApp({ commit }, app) {
      commit('updateApp', await apiRequest.update(app));
    },
  },
  getters: {
    getApps: (state) => state.apps,
  },

};
